import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down-icon",
  "use": "icon-down-icon-usage",
  "viewBox": "0 0 15 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 15 11\" id=\"icon-down-icon\">\r\n<path fill-rule=\"evenodd\" fill=\"rgb(0, 213, 255)\" d=\"M7.187,10.232 C7.105,10.232 7.022,10.213 6.945,10.174 L0.546,6.935 C0.243,6.782 0.105,6.375 0.239,6.028 C0.373,5.680 0.727,5.523 1.030,5.676 L7.187,8.792 L13.345,5.675 C13.648,5.522 14.002,5.680 14.136,6.027 C14.269,6.375 14.132,6.782 13.829,6.935 L7.430,10.174 C7.352,10.213 7.270,10.232 7.187,10.232 L7.187,10.232 ZM7.187,4.834 C7.105,4.834 7.022,4.815 6.945,4.776 L0.546,1.537 C0.243,1.384 0.105,0.978 0.239,0.630 C0.373,0.282 0.727,0.125 1.030,0.278 L7.187,3.394 L13.345,0.277 C13.648,0.124 14.002,0.281 14.136,0.629 C14.269,0.977 14.132,1.384 13.829,1.537 L7.430,4.776 C7.352,4.815 7.270,4.834 7.187,4.834 L7.187,4.834 Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/search/down-icon.svg
// module id = qxq5
// module chunks = 24